module.exports = __webpack_public_path__ + "static/media/slpst.f6fd7e56.svg";